import React, { Component } from "react"; import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import { style } from "variables/Variables.jsx";
import { Link } from "react-router-dom";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import { confirmAlert } from 'react-confirm-alert';
import { BeatLoader } from 'react-spinners';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { css } from "@emotion/core";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import DatePicker from "react-datepicker";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import "./genie_roi_module.css";
import { date_range_config, user_activities, numDifferentiationRoi } from '../../helpers/utils.js';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
// import UtidFilter from '../../filters/SingleSelectUtidFilter.jsx';
import GenieRoiUtidMultiFilter from '../../filters/GenieRoiUtidMultiFilter.jsx';
import genieplus_logo from "../../assets/img/innoviti_genie_plus.png";


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01', '0');
const d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
const today = new Date();
  const formattedDate = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(today);
class CampaignLists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datefrom: date_config.start_date,
            dateTo: date_config.end_date,
            datefromShow: date_config.display_start_date,
            dateToShow: date_config.display_end_date,
            yestSend: date_config.start_date_value,
            todSend: date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit: date_config.end_date_limit,
            ciutidIds: '',
            start_date: '',
            end_date: '',
            genie_sales_increase_benefits_left: '',
            genie_sales_increase_benefits_right: '',
            sales_from_additional_velocity_check_left: '',
            sales_from_additional_velocity_check_right: '',
            emi_wallet_left: '',
            emi_wallet_right: '',
            genie_margin_increase_benefits_left: '',
            genie_margin_increase_benefits_right: '',
            margin_from_additional_velocity_check_left: '',
            margin_from_additional_velocity_check_right: '',
            saving_on_instant_cashback_settlement_charges_left: '',
            saving_on_instant_cashback_settlement_charges_right: '',
            genie_bonus_left: '',
            genie_bonus_right: '',
            corporate_card_mdr_left: '',
            corporate_card_mdr_right: '',
            bod_margin_left: '',
            bod_margin_right: '',
            store_name: '',
            total_value_of_txns: '',
            total_no_of_txns: '',
            period: '',
            is_api_response: false,
            roiData: [],
            show_store: '',
            show_utid: '',
            store_contact_name: '',
            manager_name: '',
            response_data: [],
            progress: 0,
            currentItem: 0,
            totalItems: 0,
            show_progress_bar: false,
            is_download_button_inactive: false
        };

    }
    componentWillMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            email: decoded.email,
            user_id: decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType
        });
    }
    componentDidMount() {
        //this.setState({});
        this.get_roi_data();


    }


    get_roi_data() {
        var that = this;
        var postData = {
            utid: this.state.ciutidIds,
            start_date: this.state.yestSend,
            end_date: this.state.todSend
        }
        if ($.fn.DataTable.isDataTable('#RoiTable')) {
            $('#RoiTable').DataTable().clear().destroy();
        }
        var RoiTable = $('#RoiTable').DataTable(
            {
                order: [],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": false,
                "pageLength": 20,
                "bInfo": false,
                "sPaginationType": "numbers",
                //"autoWidth": true,
                "responsive": false,
                "scrollX": true,
                //                 "fixedColumns": {
                //                     leftColumns: 0,
                //                     rightColumns: 1
                //                 },
                "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url: config.get('API_URL') + "/summaryReport/get_roi_data",
                    type: "POST",
                    data: postData,
                    dataSrc: function (json) {
                        console.log("API Response:", json);

                        // Capture the data in a variable
                        const apiData = json.data;

                        // Set the data in state
                        that.setState({ roiData: apiData }, () => {
                            // Call setfinalData after state update
                            that.setAllData(apiData);
                        });

                        return apiData; // Return data to populate the DataTable
                    },
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },

                columns: [
                    { "data": "utid" },
                    { "data": "storecity_name" },
                    { "data": "state_name" },
                    { "data": "fieldsalesic_name" },
                    //                     {"data":"fieldsalesmanager_name"},
                    { "data": "date_converted" },
                    { "data": "contact_no" },
                    { "data": "store_name" },
                    { "data": "gtv_mtd" },
                    //                     {"data":"genie_bonus_points"},
                    { "data": "genie_bonus_value_in_terms_of_money" },
                    { "data": "emi_wallet_usage" },
                    { "data": "bod_margin" },
                    { "data": "total_corporate_mdr" },
                    { "data": "total_instant_cashback_settlement" },
                    { "data": "velocity_check_margin" },
                    { "data": "no_of_total_skus_sold" },
                    { "data": "group" }
                ],
                "createdRow": function (row, data, dataIndex) {
                    if (data['comparison'] === 'Yes') {
                        $(row).css('background-color', '#f2dede');
                        $(row).find('td').css('font-weight', 'bold');
                    }

                },
                "columnDefs": [
                    {
                        render: function (data) {
                            if (!data || data === 'NaT') {
                                return '<td></td>'; // Display 'N/A' or any placeholder you prefer
                            } else {
                                return '<td>' + moment(data).format('D MMM YYYY') + '</td>';
                            }
                        },
                        "width": "80px",
                        "targets": 4
                    },
                    {

                        "className": "text-center",
                        "targets": 15,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                            $(td).append('<a href="#" data-tip="View" title="View" id="ViewOutput" class="btn btn-default actionBtn"><i class="fa fa-eye" aria-hidden="true"></i></a>&nbsp;');

                            $(td).find('#ViewOutput').click(e => {
                                e.preventDefault(); // Prevent default link behavior
                                this.viewOutput(e, cellData);
                            });
                        },
                        bSortable: false,
                    },
                ]

            });
    }
    async viewOutput(e, cellData) {
        var selected_data = this.state.response_data.filter(item => item.group === cellData);
        await this.setfinalData(selected_data, 'view');
    }
    setAllData(apiData) {
        var is_disable = true
        if (apiData.length > 0) {
            is_disable = false;
        }
        this.setState({
            response_data: apiData,
            is_download_button_inactive: is_disable
        })
    }
    export_all = async (a, b) => {

        let groups = {};
        var all_data = this.state.response_data
        all_data.forEach(item => {
            if (!groups[item.group]) {
                groups[item.group] = [];
            }
            groups[item.group].push(item);

        });
        const total = Object.keys(groups).length; // Total groups to process
        this.setState({ totalItems: total, show_progress_bar: true, is_download_button_inactive: true }); // Set the total items count
        for (let groupKey of Object.keys(groups)) {
            this.setState(prevState => ({
                currentItem: prevState.currentItem + 1, // Increase iteration count
            }));

            // Update the progress bar based on the current item and total items
            this.setState(prevState => ({
                progress: ((prevState.currentItem) / total) * 100, // Update progress bar
            }));
            await this.setfinalData(groups[groupKey], 'all');
            await this.delay(500);
            if (a == 'Image') {
                await this.exportToImage();
            }
            if (a == 'PDF') {
                await this.exportToPDF();
            }

        }

        // Reset the progress and counters after all downloads
        this.setState({
            progress: 0,
            currentItem: 0,
            totalItems: 0,
            show_progress_bar: false,
            is_download_button_inactive: false
        });
    };

    setfinalData = async (apiData, render_type) => {

        console.log(apiData);
        var show = false;
        if (apiData.length > 0) {
            show = true;
        }
        let leftmetric = {};
        let rightmetric = {};

        // Iterate over the API data to separate left and right metrics
        apiData.forEach(item => {
            if (item.comparison === "No") {
                leftmetric = item;
            } else if (item.comparison === "Yes") {
                rightmetric = item;
            }
        });
        const installation_date = leftmetric.date_converted
        // Helper function to handle null or undefined values
        const getValueOrZero = (value) => (value != null && value !== "") ? value : 0;

        // Assign variables from the metrics
        const sales_from_additional_velocity_check_left = getValueOrZero(leftmetric.principle_value);
        const sales_from_additional_velocity_check_right = getValueOrZero(rightmetric.principle_value);

        const emi_wallet_left = getValueOrZero(leftmetric.emi_wallet_usage);
        const emi_wallet_right = getValueOrZero(rightmetric.emi_wallet_usage);

        const margin_from_additional_velocity_check_left = getValueOrZero(leftmetric.velocity_check_margin);
        const margin_from_additional_velocity_check_right = getValueOrZero(rightmetric.velocity_check_margin);

        const saving_on_instant_cashback_settlement_charges_left = getValueOrZero(leftmetric.total_instant_cashback_settlement);
        const saving_on_instant_cashback_settlement_charges_right = getValueOrZero(rightmetric.total_instant_cashback_settlement);

        const genie_bonus_left = getValueOrZero(leftmetric.genie_bonus_value_in_terms_of_money);
        const genie_bonus_right = getValueOrZero(rightmetric.genie_bonus_value_in_terms_of_money);

        const corporate_card_mdr_left = getValueOrZero(leftmetric.total_corporate_mdr);
        const corporate_card_mdr_right = getValueOrZero(rightmetric.total_corporate_mdr);

        const bod_margin_left = getValueOrZero(leftmetric.bod_margin);
        const bod_margin_right = getValueOrZero(rightmetric.bod_margin);

        var genie_sales_increase_benefits_left = Math.floor(sales_from_additional_velocity_check_left + emi_wallet_left)
        var genie_sales_increase_benefits_right = Math.floor(sales_from_additional_velocity_check_right + emi_wallet_right)

        var total_no_of_txns = getValueOrZero(leftmetric.total_number_of_txns);
        var total_value_of_txns = getValueOrZero(leftmetric.gtv_mtd);

        var genie_margin_increase_benefits_left = Math.floor(
            margin_from_additional_velocity_check_left +
            saving_on_instant_cashback_settlement_charges_left +
            genie_bonus_left +
            corporate_card_mdr_left +
            bod_margin_left
        )

        var genie_margin_increase_benefits_right = Math.floor(
            margin_from_additional_velocity_check_right +
            saving_on_instant_cashback_settlement_charges_right +
            genie_bonus_right +
            corporate_card_mdr_right +
            bod_margin_right
        )
        // Update the state with the variables
        // Calculate dynamic widths

        // Genie Sales Widths
        var genieSalesLeftWidth = this.calculateWidth(genie_sales_increase_benefits_left, genie_sales_increase_benefits_left);
        var genieSalesRightWidth = this.calculateWidth(genie_sales_increase_benefits_right, genie_sales_increase_benefits_right);

        var genieSalesLeftWidthBar = genie_sales_increase_benefits_left > 0 ? Number(genieSalesLeftWidth) + 11 : 2;
        var genieSalesRightWidthBar = genie_sales_increase_benefits_right > 0 ? Number(genieSalesRightWidth) + 11 : 2;

        // Sales Velocity Widths
        var salesVelocityLeftWidth = this.calculateWidth(sales_from_additional_velocity_check_left, genie_sales_increase_benefits_left);
        var salesVelocityRightWidth = this.calculateWidth(sales_from_additional_velocity_check_right, genie_sales_increase_benefits_right);

        var salesVelocityLeftWidthBar = sales_from_additional_velocity_check_left > 0 ? Number(salesVelocityLeftWidth) + 10 : 2;
        var salesVelocityRightWidthBar = sales_from_additional_velocity_check_right > 0 ? Number(salesVelocityRightWidth) + 10 : 2;

        // EMI Wallet Widths
        var emiWalletLeftWidth = this.calculateWidth(emi_wallet_left, genie_sales_increase_benefits_left);
        var emiWalletRightWidth = this.calculateWidth(emi_wallet_right, genie_sales_increase_benefits_right);

        var emiWalletLeftWidthBar = emi_wallet_left > 0 ? Number(emiWalletLeftWidth) + 10 : 2;
        var emiWalletRightWidthBar = emi_wallet_right > 0 ? Number(emiWalletRightWidth) + 10 : 2;

        // Genie Margin Widths
        var genieMarginLeftWidth = this.calculateWidth(genie_margin_increase_benefits_left, genie_margin_increase_benefits_left);
        var genieMarginRightWidth = this.calculateWidth(genie_margin_increase_benefits_right, genie_margin_increase_benefits_right);

        var genieMarginLeftWidthBar = genie_margin_increase_benefits_left > 0 ? Number(genieMarginLeftWidth) + 11 : 2;
        var genieMarginRightWidthBar = genie_margin_increase_benefits_right > 0 ? Number(genieMarginRightWidth) + 11 : 2;

        // Margin Velocity Widths
        var marginVelocityLeftWidth = this.calculateWidth(margin_from_additional_velocity_check_left, genie_margin_increase_benefits_left);
        var marginVelocityRightWidth = this.calculateWidth(margin_from_additional_velocity_check_right, genie_margin_increase_benefits_right);

        var marginVelocityLeftWidthBar = margin_from_additional_velocity_check_left > 0 ? Number(marginVelocityLeftWidth) + 10 : 2;
        var marginVelocityRightWidthBar = margin_from_additional_velocity_check_right > 0 ? Number(marginVelocityRightWidth) + 10 : 2;

        // Cashback Settlement Widths
        var cashbackSettlementLeftWidth = this.calculateWidth(saving_on_instant_cashback_settlement_charges_left, genie_margin_increase_benefits_left);
        var cashbackSettlementRightWidth = this.calculateWidth(saving_on_instant_cashback_settlement_charges_right, genie_margin_increase_benefits_right);

        var cashbackSettlementLeftWidthBar = saving_on_instant_cashback_settlement_charges_left > 0 ? Number(cashbackSettlementLeftWidth) + 10 : 2;
        var cashbackSettlementRightWidthBar = saving_on_instant_cashback_settlement_charges_right > 0 ? Number(cashbackSettlementRightWidth) + 10 : 2;

        // Genie Bonus Widths
        var genieBonusLeftWidth = this.calculateWidth(genie_bonus_left, genie_margin_increase_benefits_left);
        var genieBonusRightWidth = this.calculateWidth(genie_bonus_right, genie_margin_increase_benefits_right);

        var genieBonusLeftWidthBar = genie_bonus_left > 0 ? Number(genieBonusLeftWidth) + 10 : 2;
        var genieBonusRightWidthBar = genie_bonus_right > 0 ? Number(genieBonusRightWidth) + 10 : 2;

        // Corporate Card MDR Widths
        var corporateCardMdrLeftWidth = this.calculateWidth(corporate_card_mdr_left, genie_margin_increase_benefits_left);
        var corporateCardMdrRightWidth = this.calculateWidth(corporate_card_mdr_right, genie_margin_increase_benefits_right);

        var corporateCardMdrLeftWidthBar = corporate_card_mdr_left > 0 ? Number(corporateCardMdrLeftWidth) + 10 : 2;
        var corporateCardMdrRightWidthBar = corporate_card_mdr_right > 0 ? Number(corporateCardMdrRightWidth) + 10 : 2;

        // BOD Margin Widths
        var bodMarginLeftWidth = this.calculateWidth(bod_margin_left, genie_margin_increase_benefits_left);
        var bodMarginRightWidth = this.calculateWidth(bod_margin_right, genie_margin_increase_benefits_right);

        var bodMarginLeftWidthBar = bod_margin_left > 0 ? Number(bodMarginLeftWidth) + 10 : 2;
        var bodMarginRightWidthBar = bod_margin_right > 0 ? Number(bodMarginRightWidth) + 10 : 2;


        this.setState({
            genie_sales_increase_benefits_left: numDifferentiationRoi(genie_sales_increase_benefits_left),
            genie_sales_increase_benefits_right: numDifferentiationRoi(genie_sales_increase_benefits_right),
            sales_from_additional_velocity_check_left: numDifferentiationRoi(sales_from_additional_velocity_check_left),
            sales_from_additional_velocity_check_right: numDifferentiationRoi(sales_from_additional_velocity_check_right),
            emi_wallet_left: numDifferentiationRoi(emi_wallet_left),
            emi_wallet_right: numDifferentiationRoi(emi_wallet_right),
            genie_margin_increase_benefits_left: numDifferentiationRoi(genie_margin_increase_benefits_left),
            genie_margin_increase_benefits_right: numDifferentiationRoi(genie_margin_increase_benefits_right),
            margin_from_additional_velocity_check_left: numDifferentiationRoi(margin_from_additional_velocity_check_left),
            margin_from_additional_velocity_check_right: numDifferentiationRoi(margin_from_additional_velocity_check_right),
            saving_on_instant_cashback_settlement_charges_left: numDifferentiationRoi(saving_on_instant_cashback_settlement_charges_left),
            saving_on_instant_cashback_settlement_charges_right: numDifferentiationRoi(saving_on_instant_cashback_settlement_charges_right),
            genie_bonus_left: numDifferentiationRoi(genie_bonus_left),
            genie_bonus_right: numDifferentiationRoi(genie_bonus_right),
            corporate_card_mdr_left: numDifferentiationRoi(corporate_card_mdr_left),
            corporate_card_mdr_right: numDifferentiationRoi(corporate_card_mdr_right),
            bod_margin_left: numDifferentiationRoi(bod_margin_left),
            bod_margin_right: numDifferentiationRoi(bod_margin_right),
            total_no_of_txns: total_no_of_txns,
            total_value_of_txns: total_value_of_txns,
            show_store: leftmetric.store_name,
            show_utid: leftmetric.utid,
            store_contact_name: leftmetric.contact_name,
            manager_name: leftmetric.fieldsalesmanager_name,
            genieSalesLeftWidth: genieSalesLeftWidth,
            genieSalesRightWidth: genieSalesRightWidth,
            salesVelocityLeftWidth: salesVelocityLeftWidth,
            salesVelocityRightWidth: salesVelocityRightWidth,
            emiWalletLeftWidth: emiWalletLeftWidth,
            emiWalletRightWidth: emiWalletRightWidth,

            genieMarginLeftWidth: genieMarginLeftWidth,
            genieMarginRightWidth: genieMarginRightWidth,

            marginVelocityLeftWidth: marginVelocityLeftWidth,
            marginVelocityRightWidth: marginVelocityRightWidth,
            cashbackSettlementLeftWidth: cashbackSettlementLeftWidth,
            cashbackSettlementRightWidth: cashbackSettlementRightWidth,
            genieBonusLeftWidth: genieBonusLeftWidth,
            genieBonusRightWidth: genieBonusRightWidth,
            corporateCardMdrLeftWidth: corporateCardMdrLeftWidth,
            corporateCardMdrRightWidth: corporateCardMdrRightWidth,
            bodMarginLeftWidth: bodMarginLeftWidth,
            bodMarginRightWidth: bodMarginRightWidth,
            genieSalesLeftWidthBar: genieSalesLeftWidthBar,
            genieSalesRightWidthBar: genieSalesRightWidthBar,
            salesVelocityLeftWidthBar: salesVelocityLeftWidthBar,
            salesVelocityRightWidthBar: salesVelocityRightWidthBar,
            emiWalletLeftWidthBar: emiWalletLeftWidthBar,
            emiWalletRightWidthBar: emiWalletRightWidthBar,
            genieMarginLeftWidthBar: genieMarginLeftWidthBar,
            genieMarginRightWidthBar: genieMarginRightWidthBar,
            marginVelocityLeftWidthBar: marginVelocityLeftWidthBar,
            marginVelocityRightWidthBar: marginVelocityRightWidthBar,
            cashbackSettlementLeftWidthBar: cashbackSettlementLeftWidthBar,
            cashbackSettlementRightWidthBar: cashbackSettlementRightWidthBar,
            genieBonusLeftWidthBar: genieBonusLeftWidthBar,
            genieBonusRightWidthBar: genieBonusRightWidthBar,
            corporateCardMdrLeftWidthBar: corporateCardMdrLeftWidthBar,
            corporateCardMdrRightWidthBar: corporateCardMdrRightWidthBar,
            bodMarginLeftWidthBar: bodMarginLeftWidthBar,
            bodMarginRightWidthBar: bodMarginRightWidthBar,
            is_api_response: show,
            installation_date:installation_date


        });
        if (render_type == 'view') {
            const contentToExportDiv = document.getElementById('contentToExport');
            contentToExportDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

    }
    delay = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    exportToImage = async () => {
        return new Promise((resolve) => {
            const content = document.getElementById("contentToExport");
            const showUtid = this.state.show_utid ? this.state.show_utid : '';
            const storeContactName = this.state.store_contact_name ? this.state.store_contact_name : '';
            const managerName = this.state.manager_name ? this.state.manager_name : '';
            const filename = `${showUtid}_${storeContactName}_${managerName}.png`;
            html2canvas(content).then(canvas => {
                const imgData = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = imgData;
                link.download = filename;
                link.click();

                // Resolve the promise once the image has been downloaded
                resolve();
            });
        });
    };

    exportToPDF = async () => {
        return new Promise((resolve) => {
            const doc = new jsPDF(); // Create a new jsPDF document
            const content = document.getElementById("contentToExport"); // Get the content to be exported
            const showUtid = this.state.show_utid ? this.state.show_utid : '';
            const storeContactName = this.state.store_contact_name ? this.state.store_contact_name : '';
            const managerName = this.state.manager_name ? this.state.manager_name : '';
            const filename = `${showUtid}_${storeContactName}_${managerName}.pdf`;
            // Convert the content to a canvas using html2canvas
            html2canvas(content).then(canvas => {
                const imgData = canvas.toDataURL('image/png'); // Convert canvas to image data (PNG format)

                const pageWidth = doc.internal.pageSize.width; // Get the page width
                const pageHeight = doc.internal.pageSize.height; // Get the page height

                const contentWidthPx = 1100; // Set the content width in pixels (adjust as needed)
                const contentHeightPx = canvas.height; // Get the content height from the canvas

                // Conversion factor from pixels to millimeters
                const pxToMm = 25.4 / 96;

                // Calculate content width and height in millimeters
                const contentWidthMm = contentWidthPx * pxToMm;
                const contentHeightMm = contentHeightPx * pxToMm;

                // Calculate scaling factor to fit the content within the page
                const scaleX = pageWidth / contentWidthMm;
                const scaleY = pageHeight / contentHeightMm;

                const scale = Math.min(scaleX, scaleY); // Pick the smaller scale to fit content

                // Add the image to the PDF document with scaled dimensions
                doc.addImage(imgData, 'PNG', 0, 0, contentWidthMm * scale, contentHeightMm * scale);

                // Save the PDF with the given filename
                doc.save(filename);

                // Resolve the promise once the PDF has been downloaded
                resolve();
            });
        });
    };

    handleDateRange = (todSend, yestSend, datefromShow, dateToShow) => {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        this.refs.reloadUtid.getRoiUtid(yestSend, todSend);
    }
    downLoadRoi(e) {
        let filters = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            utid: this.state.ciutidIds,
            download: 1
        }
        this.setState({
            filters: filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, '/genie_roi/genie_roi_report', 'genie_roi');
    }
    handleFromChangeRaw = (e) => {
        const inputValue = e.target.value;
        if (!moment(inputValue, "YYYY-MM-DD", true).isValid()) {
            console.log("invalid")
            this.setState({
                start_date: ""
            });
        } else {
            console.log("valid")
            this.setState({
                start_date: inputValue
            });
        }
    };
    //     exportToPDF = () => {
    //         const doc = new jsPDF();
    //         const content = document.getElementById("contentToExport");
    //         html2canvas(content).then(canvas => {
    //             const imgData = canvas.toDataURL('image/png');
    //             doc.addImage(imgData, 'PNG', 0, 0);
    //             var filename = new Date().getTime()+'_genie_roi.pdf'
    //             doc.save(filename);
    //         });
    //     };
    //     exportToPDF = () => {
    //     const doc = new jsPDF();
    //     const content = document.getElementById("contentToExport");
    //     html2canvas(content).then(canvas => {
    //         const imgData = canvas.toDataURL('image/png');
    //         const pageWidth = doc.internal.pageSize.width;
    //         const pageHeight = doc.internal.pageSize.height;
    //
    //         const contentWidthPx = 1100;
    //         const contentHeightPx = canvas.height;
    //
    //         const pxToMm = 25.4 / 96;
    //
    //         const contentWidthMm = contentWidthPx * pxToMm;
    //         const contentHeightMm = contentHeightPx * pxToMm;
    //
    //         const scaleX = pageWidth / contentWidthMm;
    //         const scaleY = pageHeight / contentHeightMm;
    //
    //         const scale = Math.min(scaleX, scaleY);
    //
    //         doc.addImage(imgData, 'PNG', 0, 0, contentWidthMm * scale, contentHeightMm * scale);
    //         var filename = this.state.show_utid+'_'+this.state.store_contact_name+'_'+this.state.manager_name+'.pdf'
    //         doc.save(filename);
    //     });
    // };

    handleUtid = (optionSelected, utid) => {
        this.setState({
            ciutidIds: utid,
            isChange: true,
            is_download_button_inactive: true
        });
    }


    calculateWidth = (val, maxValue) => {
        //     var percentage = (val / maxValue) * 100;
        //     var width = Math.max(2, Math.min(percentage, 80)).toFixed(2);
        if (val === 0 || maxValue === 0) {
            return "2";
        }
        var percentage = (val / maxValue) * 100;
        // Dynamic minimum threshold based on val's scale
        var minThreshold = Math.min(5, Math.log10(val) + 1);
        var width = Math.max(minThreshold, Math.min(percentage, 80)).toFixed(2);
        if (val < maxValue && width > 79) { width = parseFloat(width) - 1 }
        if (val > 0 && width < 3) { width = parseFloat(width) + 1 }

        return width; // Returns a string representing the width percentage
    };
    //     calculateWidth = (val,maxValue) => {
    //
    //     var percentage = (val / maxValue) * 100;
    //     var width = Math.max(2, Math.min(percentage, 80)).toFixed(2);
    //     if(val==0)  {
    //         width = 2
    //         return width
    //     }
    //     if(val<maxValue && width>79)
    //     { width = parseFloat(width)-1 }
    //     if(val>0 && width<3)
    //     { width = parseFloat(width)+1 }
    //
    //     return width; // Returns a string representing the width percentage
    // };

    // calculateWidth = (val, maxValue) => {
    //     const percentage = (val / maxValue) * 100;
    //
    //     // Introduce a scaling factor for high percentages near the max
    //     const scaledPercentage = percentage >= 99
    //         ? percentage - (percentage - 99) * 0.5 // Gradually reduce if near 100%
    //         : percentage;
    //
    //     const width = Math.max(2, Math.min(scaledPercentage, 80)).toFixed(2);
    //     return width; // Returns a string representing the width percentage
    // };
    render() {
        console.log("sfsf", this.state.roiData)
        const { progress, currentItem, totalItems } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <NotificationSystem
                                    ref="notificationSystem"
                                    style={style}
                                />
                                <div className="content">
                                    <div className="row">
                                        <NotificationSystem
                                            ref="notificationSystem"
                                            style={style}
                                        />
                                        <div className="col-md-12">


                                            <div className="col-md-2 ">
                                                <label> Date Filter: </label>
                                                <DateRangeFilter
                                                    ref="daterangeFilter"
                                                    onSelectDate={this.handleDateRange}
                                                    start_date={this.state.datefrom}
                                                    end_date={this.state.dateTo}
                                                    display_start_date={
                                                        this.state.datefromShow
                                                    }
                                                    display_end_date={this.state.dateToShow}
                                                    start_date_limit={
                                                        this.state.dateFromLimit
                                                    }
                                                    end_date_limit={this.state.dateLimit}
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <GenieRoiUtidMultiFilter ref="reloadUtid" onSelectUtid={this.handleUtid} start_date={this.state.yestSend} end_date={this.state.todSend} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-5">

                                                <button
                                                    type="button"
                                                    className="primary apply-filter roi-btn"
                                                    role="button"
                                                    disabled={this.state.is_download_button_inactive}
                                                    onClick={this.export_all.bind(
                                                        this, 'PDF'
                                                    )}
                                                ><i
                                                    className="fa fa-file-pdf-o"
                                                    aria-hidden="true"
                                                ></i>
                                                    Export to Pdf
                                                </button>
                                                <label> &nbsp; </label>
                                                <button
                                                    type="button"
                                                    className="primary apply-filter roi-btn"
                                                    role="button"
                                                    disabled={this.state.is_download_button_inactive}
                                                    onClick={this.export_all.bind(
                                                        this, 'Image'
                                                    )}
                                                >
                                                    <i
                                                        className="fa fa-image"
                                                        aria-hidden="true"
                                                    ></i>
                                                    Export to Image
                                                </button>


                                                <label> &nbsp; </label>
                                                <button
                                                    type="button"
                                                    className="primary apply-filter roi-btn"
                                                    role="button"
                                                    onClick={this.get_roi_data.bind(
                                                        this
                                                    )}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                            <div className="col-md-3">


                                                {this.state.show_progress_bar == true ?
                                                    <div>
                                                        <div style={{ width: '100%', backgroundColor: '#f3f3f3', borderRadius: '5px', marginTop: '30px' }}>
                                                            <div
                                                                style={{
                                                                    height: '15px',
                                                                    width: `${progress}%`,
                                                                    backgroundColor: 'green',
                                                                    borderRadius: '5px',
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Text Display for Download Progress */}
                                                        <div>
                                                            <span className="downloading_text">Downloading {currentItem} of {totalItems}</span>
                                                        </div> </div> : null}
                                            </div>
                                        </div>
                                        {/*                                         <div className="col-md-12 pull-right"> */}

                                        {/*                                              */}
                                        {/*                                         </div> */}
                                    </div>
                                </div>
                                <hr className="m-0 p-0" />
                                <div className="content table-full-width table-responsive nomargin">
                                    <div className="">
                                        <div className="col-md-8">
                                            <div className="header">
                                                <h4 className="title">
                                                    GENIE ROI
                                                </h4>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="">
                                        <a
                                            href="#"
                                            className="exportButton"
                                            role="button"
                                            onClick={this.downLoadRoi.bind(this)}
                                        >
                                            <i
                                                className="fa fa-download"
                                                aria-hidden="true"
                                            ></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <table
                                        id="RoiTable"
                                        className="table table-striped table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <th>UTID</th>
                                                <th>City</th>
                                                <th>State</th>
                                                <th>Field Sales representative</th>
                                                {/*                                                 <th>Manager name of the IC</th> */}
                                                <th>Date Converted</th>
                                                <th>Store Owner contact number</th>
                                                <th>Store name</th>
                                                <th>GTV MTD</th>
                                                {/*                                                 <th>Genie Bonus points</th> */}
                                                <th>Genie Bonus Value in terms of Money</th>
                                                <th>EMI wallet usage</th>
                                                <th>BOD Margin drawn (Sales made during BOD)</th>
                                                <th>Corporate MDR</th>
                                                <th>Instant Settlement</th>
                                                <th>Velocity check Margin</th>
                                                <th>No. of total SKUs sold</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <hr className="m-0 p-0" />
                                {this.state.is_api_response === true ?
                                    <div className="content">
                                        <div className="button_container">
                                            <a
                                                href="#"
                                                className="exportPdfButton"
                                                role="button"
                                                onClick={this.exportToImage}
                                            >
                                                <i
                                                    className="fa fa-image"
                                                    aria-hidden="true"
                                                ></i>
                                                Export to Image
                                            </a>
                                            <a
                                                href="#"
                                                className="exportPdfButton"
                                                role="button"
                                                onClick={this.exportToPDF}
                                            >
                                                <i
                                                    className="fa fa-file-pdf-o"
                                                    aria-hidden="true"
                                                ></i>
                                                Export to PDF
                                            </a>
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="roi_container" id="contentToExport">
                                            <div>
                                                <table
                                                    className="tablehead"
                                                    border="0"
                                                    width="100%"
                                                >
                                                    <tr>
                                                        <td
                                                            className="section-title"
                                                            width="30%"
                                                        >
                                                            <div className="store-info">
                                                                <p>
                                                                    Total no of transactions:{" "}
                                                                    <span className="color-val">
                                                                        {this.state.total_no_of_txns}
                                                                    </span>
                                                                    <br />
                                                                    Total value of transaction:{" "}
                                                                    <span className="color-val">
                                                                        ₹{(this.state.total_value_of_txns || 0).toLocaleString('en-IN')}
                                                                    </span>
                                                                    <br />
                                                                    Period:{" "}
                                                                    <span className="color-val">

                                                                        {moment(this.state.installation_date).format('D MMM YYYY')} -&nbsp;
                                                                        {formattedDate}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </td>
                                                        <td width="40%" className="headcontent">
                                                            <div className="header1">
                                                                Genie Promise Delivery
                                                            </div>
                                                            <p>{this.state.show_store} - {this.state.show_utid}
                                                                {/*                                                             <b>PAVAN</b> */}
                                                                {/*                                                             <br /> */}
                                                                {/*                                                             SRI VEERABHADRA MOBILES */}
                                                            </p>
                                                            <p>{this.state.store_contact_name}</p>
                                                        </td>
                                                        <td width="30%" className="logo-td">
                                                            <img
                                                                src={genieplus_logo}
                                                                alt="genieplus_logo"
                                                                style={{ width: "65%" }}
                                                            />
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div>
                                                <table
                                                    border="1"
                                                    className="detailedTable"
                                                    width="100%"
                                                >
                                                    <tr className="grey-back">
                                                        <td
                                                            rowspan="3"
                                                            width="20%"
                                                            className="increase-benefits"
                                                        >
                                                            Genie Sales Increase Benefits
                                                        </td>
                                                        <td
                                                            colspan="3"
                                                            width="80%"
                                                            className="sales-increase"
                                                        >
                                                            Total Sales Increase
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            width="40%"
                                                            className="your-increase"
                                                        >
                                                            <div className="txt-inc">
                                                                Your Increase
                                                            </div>
                                                            <div
                                                                id="base"
                                                                style={{ right: `${Math.max(this.state.genieSalesLeftWidth - 24, 2)}%` }}
                                                            >
                                                                ₹<br />{(this.state.genie_sales_increase_benefits_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green"
                                                                style={{ width: `${this.state.genieSalesLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td
                                                            width="40%"
                                                            className="max-increase"
                                                        >
                                                            <div className="max-inc-5">
                                                                Maximum Increase Within 5km Of
                                                                Your Store
                                                            </div>
                                                            <div
                                                                id="base-red"
                                                                style={{ right: `${Math.max(this.state.genieSalesRightWidth - 51, 2)}%` }}
                                                            >
                                                                ₹<br />
                                                                {(this.state.genie_sales_increase_benefits_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red"
                                                                style={{ width: `${this.state.genieSalesRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            className="grey-back-details"
                                                            colspan="3"
                                                            width="80%"
                                                        >
                                                            Details
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" className="r2td1">
                                                            Sales from additional velocity-check
                                                        </td>
                                                        <td width="40%" className="r2td2">
                                                            <div
                                                                id="base-green-details"
                                                                style={{ right: `${this.state.salesVelocityLeftWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.sales_from_additional_velocity_check_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green-details"
                                                                style={{ width: `${this.state.salesVelocityLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td width="40%" className="r2td3">
                                                            <div
                                                                id="base-red-details"
                                                                style={{ right: `${this.state.salesVelocityRightWidth}%` }}
                                                            >
                                                                ₹<br />
                                                                {(this.state.sales_from_additional_velocity_check_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red-details"
                                                                style={{ width: `${this.state.salesVelocityRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" className="r2td1">
                                                            EMI Wallet
                                                        </td>
                                                        <td width="40%" className="r2td2">
                                                            <div
                                                                id="base-green-details"
                                                                style={{ right: `${this.state.emiWalletLeftWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.emi_wallet_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green-details"
                                                                style={{ width: `${this.state.emiWalletLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td width="40%" className="r2td3">
                                                            <div
                                                                id="base-red-details"
                                                                style={{ right: `${this.state.emiWalletRightWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.emi_wallet_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red-details"
                                                                style={{ width: `${this.state.emiWalletRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>
                                                    <tr className="grey-back">
                                                        <td
                                                            rowspan="3"
                                                            width="20%"
                                                            className="increase-benefits"
                                                        >
                                                            Genie Margin Increase Benefits
                                                        </td>
                                                        <td
                                                            colspan="3"
                                                            width="80%"
                                                            className="sales-increase"
                                                        >
                                                            Total Margin Increase
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            width="40%"
                                                            className="your-increase"
                                                        >
                                                            <div className="txt-inc">
                                                                Your Increase
                                                            </div>
                                                            <div
                                                                id="base"
                                                                style={{ right: `${Math.max(this.state.genieMarginLeftWidth - 24, 2)}%` }}
                                                            >
                                                                ₹<br />{(this.state.genie_margin_increase_benefits_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green"
                                                                style={{ width: `${this.state.genieMarginLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td
                                                            width="40%"
                                                            className="max-increase"
                                                        >
                                                            <div className="max-inc-5">
                                                                Maximum Increase Within 5km Of
                                                                Your Store
                                                            </div>
                                                            <div
                                                                id="base-red"
                                                                style={{ right: `${Math.max(this.state.genieMarginRightWidth - 51, 2)}%` }}
                                                            >
                                                                ₹<br />
                                                                {(this.state.genie_margin_increase_benefits_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red"
                                                                style={{ width: `${this.state.genieMarginRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            className="grey-back-details"
                                                            colspan="3"
                                                            width="80%"
                                                        >
                                                            Details
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" className="r2td1">
                                                            Margin from additional velocity-check
                                                        </td>
                                                        <td width="40%" className="r2td2">
                                                            <div
                                                                id="base-green-details"
                                                                style={{ right: `${this.state.marginVelocityLeftWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.margin_from_additional_velocity_check_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green-details"
                                                                style={{ width: `${this.state.marginVelocityLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td width="40%" className="r2td3">
                                                            <div
                                                                id="base-red-details"
                                                                style={{ right: `${this.state.marginVelocityRightWidth}%` }}
                                                            >
                                                                ₹<br />
                                                                {(this.state.margin_from_additional_velocity_check_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red-details"
                                                                style={{ width: `${this.state.marginVelocityRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" className="r2td1">
                                                            Saving on instant cashback settlement charges
                                                        </td>
                                                        <td width="40%" className="r2td2">
                                                            <div
                                                                id="base-green-details"
                                                                style={{ right: `${this.state.cashbackSettlementLeftWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.saving_on_instant_cashback_settlement_charges_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green-details"
                                                                style={{ width: `${this.state.cashbackSettlementLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td width="40%" className="r2td3">
                                                            <div
                                                                id="base-red-details"
                                                                style={{ right: `${this.state.cashbackSettlementRightWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.saving_on_instant_cashback_settlement_charges_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red-details"
                                                                style={{ width: `${this.state.cashbackSettlementRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" className="r2td1">
                                                            Genie Bonus
                                                        </td>
                                                        <td width="40%" className="r2td2">
                                                            <div
                                                                id="base-green-details"
                                                                style={{ right: `${this.state.genieBonusLeftWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.genie_bonus_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green-details"
                                                                style={{ width: `${this.state.genieBonusLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td width="40%" className="r2td3">
                                                            <div
                                                                id="base-red-details"
                                                                style={{ right: `${this.state.genieBonusRightWidth}%` }}
                                                            >
                                                                ₹<br />
                                                                {(this.state.genie_bonus_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red-details"
                                                                style={{ width: `${this.state.genieBonusRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" className="r2td1">
                                                            Corporate Card MDR
                                                        </td>
                                                        <td width="40%" className="r2td2">
                                                            <div
                                                                id="base-green-details"
                                                                style={{ right: `${this.state.corporateCardMdrLeftWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.corporate_card_mdr_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green-details"
                                                                style={{ width: `${this.state.corporateCardMdrLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td width="40%" className="r2td3">
                                                            <div
                                                                id="base-red-details"
                                                                style={{ right: `${this.state.corporateCardMdrRightWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.corporate_card_mdr_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red-details"
                                                                style={{ width: `${this.state.corporateCardMdrRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" className="r2td1">
                                                            BOD Margin
                                                        </td>
                                                        <td width="40%" className="r2td2">
                                                            <div
                                                                id="base-green-details"
                                                                style={{ right: `${this.state.bodMarginLeftWidth}%` }}
                                                            >
                                                                ₹<br />{(this.state.bod_margin_left || 0).toLocaleString('en-IN')}
                                                            </div>

                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-green-details"
                                                                style={{ width: `${this.state.bodMarginLeftWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                        <td width="40%" className="r2td3">
                                                            <div
                                                                id="base-red-details"
                                                                style={{ right: `${this.state.bodMarginRightWidth}%` }}
                                                            >
                                                                ₹<br />
                                                                {(this.state.bod_margin_right || 0).toLocaleString('en-IN')}
                                                            </div>
                                                            <div className="clearfix"></div>
                                                            <div
                                                                className="progress-bar-red-details"
                                                                style={{ width: `${this.state.bodMarginRightWidthBar}%` }}
                                                            ></div>
                                                            <div className="clearfix"></div>
                                                        </td>
                                                    </tr>

                                                </table>
                                            </div>
                                        </div>
                                    </div> : null}

                                {/*                                 <div style={{ marginTop: "20px" }}> */}
                                {/*                                     <button onClick={this.exportToPDF}> */}
                                {/*                                         Export as PDF */}
                                {/*                                     </button> */}
                                {/*                                     <button onClick={this.exportToImage}> */}
                                {/*                                         Export as Image */}
                                {/*                                     </button> */}
                                {/*                                 </div> */}
                                <DownloadAllReport ref="downloadAllReport" />
                                <div className="footer">
                                    <div className="stats">
                                        <i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CampaignLists